import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { startLogin, otpVerification, otpVerify } from '../../actions/auth';
import LoginForm from './LoginForm';
import SendEmailForm from './SendEmailForm';
import { reset } from '../../api/api';
import { pushToDataLayer } from '../../utils/gtmUtils';
import OTPFormPage from '../OTPPage/OTPFormPage';

export class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayForm: 'login',
      displayNewPasswordForm: false,
      validSendEmail: false,
      validSendOTP: false,
      title: 'Se Connecter',
      spinner: 'inactive',
      sendEmailSpinner: 'inactive',
      sendOTPSpinner: 'inactive',
      errorSendEmailMessage: '',
      errorSendOTPMessage: '',
      pathName: props.location.pathname,
      messageLogin: {
        display: false,
        text: '',
      }
    }
    this.onCLickForgotPassword = this.onCLickForgotPassword.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.messages !== this.props.messages) {
      this.setState({
        messageLogin: this.props.messages.login
      });
    }
  }


  onCLickForgotPassword() {
    this.setState({ displayForm: 'email', title: 'Modifier le mot de passe' });
  }
  onSubmit = (credentials) => {

    const dataLayer = {
      event: "login",
      url: window.location.href,
      user: credentials.userName,
      idPartenaire: this.props.partenaireData.id
    }
    pushToDataLayer(dataLayer);

    this.setState({ spinner: 'active' })
    this.props.startLogin(credentials)
      .then((result) => {
        console.log('Login success:', result);
        this.setState({ displayForm: 'OTP', title: 'Code de vérification' });
      })
      .catch((error) => {
        console.error('Login failed:', error);
      });
    setTimeout(() => { this.setState({ spinner: 'inactive' }) }, 500);
  }

  sendEmail = (data) => {
    const dataLayer = {
      event: "resetPassword",
      url: window.location.href,
      idPartenaire: this.props.partenaireData.id
    }
    pushToDataLayer(dataLayer);
    this.setState({ sendEmailSpinner: 'active' });
    reset(data).then(() => {
      setTimeout(() => { this.setState({ sendEmailSpinner: 'inactive' }) }, 500);
      this.setState({ validSendEmail: true, errorSendEmailMessage: '' });
    }, error => {
      this.setState({ errorSendEmailMessage: 'E-mail incorrect ' });
      setTimeout(() => { this.setState({ sendEmailSpinner: 'inactive' }) }, 500);
      console.log(error);
    })

  }

  sendOTP = (data) => {
    this.setState({ sendOTPSpinner: 'active' });
    const decoded = atob(sessionStorage.defaultID); // Base64 → string
    const [userName, password, memoryCharged, origin] = decoded.split('|');
    const cred = {
      userName: userName,
      urlPartnerie: origin,
      code: data.otpNumber
    }
    this.props.otpVerify(cred).then((res) => {
      setTimeout(() => { this.setState({ sendOTPSpinner: 'inactive' }) }, 500);
      this.setState({ validSendOTP: true, errorSendOTPMessage: '' });
      this.props.history.push('/accueil');

    }, error => {
      this.setState({ errorSendOTPMessage: 'Code de vérification incorrect.' });
      // setTimeout(() => { this.setState({ sendEmailSpinner: 'inactive' }) }, 500);
      console.log(error);
    })
  }

  render() {
    return (
      <div className="login-main">
        <div className="page-background"></div>
        <div className="container login-container">
          <div className="bloc-form">
            <h2>{this.state.title}</h2>
            {this.state.displayForm === 'login' &&
              <LoginForm
                onSubmit={this.onSubmit}
                onCLickForgotPassword={this.onCLickForgotPassword}
                spinner={this.state.spinner}
                pathName={this.state.pathName}
              />
            }
            {this.state.displayForm === 'email' &&
              <div>
                {!this.state.validSendEmail ?
                  <SendEmailForm
                    sendEmail={this.sendEmail}
                    spinner={this.state.sendEmailSpinner}
                  />
                  :
                  <div className="bloc-from_success">
                    <img src='/images/yes.png' alt="image" />
                    <p className="validation-txt">
                      Vous allez recevoir un mail de confirmation avec un lien d’activation de votre espace de recueil de mémoire.
                    </p>
                  </div>
                }
              </div>
            }
            {this.state.displayForm === 'OTP' &&
              <div>
                {!this.state.validSendOTP ?
                  <OTPFormPage
                    sendOTP={this.sendOTP}
                    spinner={this.sendOTPSpinner}
                  /> :
                  <div></div>}
              </div>
            }

            <div className="bloc-form_error">
              {
                this.state.messageLogin.display &&
                <div className="alert alert-danger" >
                  {this.state.messageLogin.text} <br />
                  <span className="small-txt">Accès au site refusé </span>
                </div>
              }
              {this.state.errorSendEmailMessage &&
                <div className="alert alert-danger single-line" role="alert">{this.state.errorSendEmailMessage}</div>
              }
              {this.state.errorSendOTPMessage &&
                <div className="alert alert-danger single-line" role="alert">{this.state.errorSendOTPMessage}</div>
              }
            </div>
          </div>
          <div className="signon-container">
            <div className="col-sm-5 text-bloc">
              <h2>Première Visite ?</h2>
              <p className>Inscrivez-vous pour bénéficier gratuitement du service. Il vous est offert par votre complémentaire obsèques.</p>
              <Link to="/sinscrire"><button type="button" className="btn btn-light btn-lg btn-login">M'INSCRIRE</button></Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  startLogin: (credentials) => dispatch(startLogin(credentials)),
  otpVerify: (data) => dispatch(otpVerify(data))

});

const mapStateToProps = (state) => ({
  messages: state.messages,
  partenaireData: state.partenaireData
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/components/LoginPage/LoginPage.js